export const errorMessages = {
    errorDoughThickness: "Lütfen hamur kalınlığı seçiniz.",
    errorNameInputEmpty: "İsim alanı boş olamaz.",
    errorNameInputMin: "İsim en az iki karakterden oluşmalı"
}

export const testAttributes = {
    inputCustomerName: "input-customer-name",
    inputNotes: "input-notes",
    inputDoughThickness: "input-dough-thickness",
    error: "error"
}